<template>
  <div class="Index">
    <router-view />
    <Operation />
    <Footer />
  </div>
</template>

<script>
import Operation from "@/components/Operation.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Index",
  components: {
    Operation,
    Footer,
  },
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style scoped lang="scss">
::v-deep .el-input__inner:focus {
  border-color: $primary;
}

::v-deep .el-dialog__title {
  color: $primary;
}

::v-deep .el-button--primary {
  background-color: $primary;
  border-color: $primary;
}

::v-deep .el-button--primary:hover {
  background: $primary-hover;
  border-color: $primary-hover;
}

::v-deep .el-button--primary:focus {
  background: $primary-focus;
  border-color: $primary-focus;
}
::v-deep .el-button--primary:active {
  background: $primary-active;
  border-color: $primary-active;
}
</style>
